import { render, staticRenderFns } from "./ChangePhoneForm.vue?vue&type=template&id=608a9a9c&scoped=true&"
import script from "./ChangePhoneForm.vue?vue&type=script&lang=js&"
export * from "./ChangePhoneForm.vue?vue&type=script&lang=js&"
import style0 from "./ChangePhoneForm.vue?vue&type=style&index=0&id=608a9a9c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "608a9a9c",
  null
  
)

export default component.exports